import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProfileInfos, editProfileInfos, createImg, createAddress } from '../../services/UserService';
import bgimage from '../../images/no-img-avatar.png';
import { Modal } from 'react-bootstrap';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function CadastroForm() {

    const [file, setFile] = useState(null);
    const [base64Image, setBase64Image] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [personData, setPersonData] = useState(null);

    const [addressData, setAddressData] = useState({
        Street: "",
        Number: "",
        Neighborhood: "",
        City: "",
        State: "",
        ZipCode: "",
        Country: "",
        Latitude: 0,
        Longitude: 0
    });

    const [toggle, setToggle] = useState(false);
    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(true)
    const [modalNewAddress, setModalNewAddress] = useState(false)
    const [modalMSG, setModalMSG] = useState(false)

    const [showAddressFields, setShowAddressFields] = useState(false);
    const [isEditingAddress, setIsEditingAddress] = useState(false);

    const [formattedValues, setFormattedValues] = useState({
        phone: "",
        taxId: "",
        zipcode: ""
    });

    const handlePersonChange = (e) => {
        const { name, value } = e.target;
        setPersonData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const combinedData = {
            ...personData,
            address: addressData,
        };
    };

    const fileHandler = (e) => {
        const file = e.target.files[0];
        if (file && file.size < 1048576) { // Verifica se o arquivo tem menos de 1MB
            setFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setBase64Image(reader.result); // Armazena a imagem em base64
            };
            reader.readAsDataURL(file)
        } else {
            setErrorMessage("A imagem deve ter menos de 1MB.");
            setFile(null);
            setBase64Image(null);
        }
    };

    const RemoveImage = () => {
        setFile(null);
        setBase64Image(null);
    };

    const checkProfile = async () => {
        try {
            const response = await getProfileInfos();
            if (response.status === 200) {
                setPersonData(response.data.result);
            } else {
                console.error('Erro ao checar profile:', response.statusText);
            }
        } catch (error) {
            console.error('Erro ao checar profile:', error);
        } finally {
            setLoading(false);
        }
    };

    const insertImg = async () => {
        try {
            const fetchImg = async () => {
                const treatedBase64Image = base64Image.replace(/^data:image\/[a-z]+;base64,/, '');
                try {
                    const response = await createImg(personData.id, file.name, 0, true, treatedBase64Image);
                    if (response.status === 200) {
                        setToggle(false)
                        setModalMSG(true)
                        setMessage('nova imagem inserida com sucesso!')
                    } else {
                        console.error('Erro ao checar profile:', response.statusText);
                    }
                } catch (error) {
                    console.error('Erro ao checar profile:', error);
                }
            };
            fetchImg();
        } catch (error) {
            console.error('Erro ao obter o valor de "p" da URL:', error);
        }
    };

    const updateProfile = async () => {
        try {
            const payload = { ...personData };

            // regra: se o número (sem DDI) tiver 11 dígitos e o terceiro for 9, removemos o 9
            let phone = payload.phone?.replace(/^55/, "") || "";
            if (phone.length === 11 && phone[2] === "9") {
                phone = phone.slice(0, 2) + phone.slice(3); // remove o '9' após o DDD
            }
            // adiciona o DDI 55 novamente
            payload.phone = `55${phone}`;
            payload.username = payload.phone;
            payload.password = payload.phone;

            const response = await editProfileInfos(payload);
            if (response.status === 200) {
                setToggle(false);
                setModalMSG(true);
                setMessage('Seus dados foram atualizados com sucesso!');
            } else {
                console.error('Erro ao checar profile:', response.statusText);
            }
        } catch (error) {
            console.error('Erro ao checar profile:', error);
        }
    };

    const createNewAddress = async (Street, Number, Neighborhood, City, State, ZipCode, Latitude, Longitude) => {
        try {
            const fetchProfile = async () => {
                try {
                    const response = await createAddress(Street, Number, Neighborhood, City, State, ZipCode, Latitude, Longitude);
                    if (response.status === 200) {
                        setToggle(false)
                        setModalMSG(true)
                        setMessage('endereço cadastrado com sucesso!')
                    } else {
                        console.error('Erro ao criar endereço:', response.statusText);
                    }
                } catch (error) {
                    console.error('Erro ao criar endereço:', error);
                }
            };
            fetchProfile();
        } catch (error) {
            console.error('Erro ao obter o valor de "p" da URL:', error);
        }
    };

    const handleAddressSubmit = (newAddress) => {
        createNewAddress(newAddress.street, newAddress.number, newAddress.neighborhood, newAddress.city, newAddress.state, newAddress.zipCode, newAddress.latitude, newAddress.longitude)
    };

    // funções de formatação (mantidas iguais)
    const formatPhone = (value) => {
        const numbers = value.replace(/\D/g, "");

        if (numbers.length <= 2) {
            return numbers; // apenas DDD
        } else if (numbers.length <= 6) {
            return numbers.replace(/^(\d{2})(\d{0,4})/, "($1) $2");
        } else if (numbers.length <= 10) {
            // fixo: (85) 3731-3090
            return numbers.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, "($1) $2-$3");
        } else {
            // celular: (85) 99731-3090
            return numbers.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, "($1) $2-$3");
        }
    };

    const formatCNPJ = (value) => {
        const numbers = value.replace(/\D/g, "");
        return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, "$1.$2.$3/$4-$5");
    };

    // atualiza telefone formatado e também username/senha com DDI
    const handlePhoneChange = (e) => {
        const { value } = e.target;
        // mantém a digitação e formata normalmente
        const formattedPhone = formatPhone(value);
        setFormattedValues(prev => ({ ...prev, phone: formattedPhone }));

        // apenas limpa os dígitos para armazenar no estado bruto
        const cleanNumber = value.replace(/\D/g, "");

        // ainda não aplicamos a remoção do "9" — isso será feito só ao enviar para o backend
        setPersonData(prev => ({
            ...prev,
            phone: cleanNumber,
        }));
    };


    // atualiza CNPJ formatado
    const handleCNPJChange = (e) => {
        const { value } = e.target;
        const formattedCNPJ = formatCNPJ(value);
        setFormattedValues(prev => ({ ...prev, taxId: formattedCNPJ }));

        const cleanNumber = value.replace(/\D/g, "");
        setPersonData(prev => ({
            ...prev,
            taxId: cleanNumber
        }));
    };

    // sempre que personData mudar (ex: após checkProfile)
    useEffect(() => {
        if (personData) {
            setFormattedValues({
                phone: personData.phone ? formatPhone(personData.phone.replace(/^55/, "")) : "",
                taxId: personData.taxId ? formatCNPJ(personData.taxId) : "",
                zipcode: personData.zipCode || ""
            });
        }
    }, [personData]);

    useEffect(() => {
        if (!toggle) {
            checkProfile()
            setToggle(true)
        }
    }, [toggle])

    return (
        <>
            {loading ? (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "100vh" }}
                >
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </div>
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <div className='row'>
                        <div className='col-12'>
                            <br />
                            <h3><i className="bi bi-card-image"></i> Imagem de exibição</h3>
                            <hr />
                        </div>
                        <div className='col-12'>

                            <div className="avatar-upload d-flex align-items-center justify-content-center">
                                <div className="change position-relative d-flex">
                                    <div className="avatar-preview" style={{ maxWidth: 120 }}>
                                        {
                                            !loading ? (
                                                personData && personData.images && personData.images.length > 0 ? (
                                                    <img
                                                        id="saveImageFile"
                                                        src={file ? URL.createObjectURL(file) : personData && personData.images.length > 0 ? 'https://core.pskeromais.com.br/' + personData.images[personData.images.length - 1].url : ''}
                                                        alt={file ? file.name : "Imagem Padrão"}
                                                        style={{ maxWidth: 120 }}
                                                    />
                                                ) : (
                                                    <img
                                                        id="saveImageFile"
                                                        src={file ? URL.createObjectURL(file) : bgimage}
                                                        alt={file ? file.name : "Imagem Padrão"}
                                                        style={{ maxWidth: 120 }}
                                                    />
                                                )
                                            ) : null
                                        }
                                    </div>
                                    <div className="change-btn d-flex align-items-center flex-wrap">
                                        <input
                                            type='file'
                                            onChange={fileHandler}
                                            className="form-control"
                                            id="imageUpload"
                                            accept=".png, .jpg, .jpeg"
                                        />
                                        <div className="change-btn d-flex flex-column flex-wrap gap-4">
                                            <label htmlFor="imageUpload" className="dlab-upload">{personData && personData.images && personData.images.length > 0 ? ("Escolher Outro Arquivo") : "Escolher Arquivo"}</label>
                                            <Link to={"#"} className="btn remove-img ms-2 bg-light" onClick={RemoveImage}>Remover</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br /><br />
                            <div className="change-btn d-flex align-items-center align-content-center bg-light p-3 justify-content-center flex-wrap">
                                <button to={"#"} className="btn btn-primary ms-2" onClick={() => insertImg()}>Enviar Imagem</button>
                            </div>

                        </div>
                        <div className='col-12'>
                            <br />
                            <h3><i className="bi bi-person-lines-fill"></i> Dados Pessoais</h3>
                            <hr />
                        </div>
                        <div className='col-md-6'>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Nome</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={personData ? personData.name : ''}
                                    onChange={handlePersonChange}
                                    className="form-control"
                                    id="name"
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={personData ? personData.email : ''}
                                    onChange={handlePersonChange}
                                    className="form-control"
                                    id="email"
                                />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="mb-3">
                                <label htmlFor="cpf" className="form-label">CNPJ</label>
                                <input
                                    type="text"
                                    name="taxId"
                                    value={formattedValues.taxId}
                                    onChange={handleCNPJChange}
                                    maxLength={18}
                                    placeholder="00.000.000/0000-00"
                                    className="form-control"
                                    id="cpf"
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="phone" className="form-label">Telefone</label>
                                <input
                                    type="text"
                                    name="phone"
                                    value={formattedValues.phone}
                                    onChange={handlePhoneChange}
                                    maxLength={15}
                                    placeholder="(00) 00000-0000"
                                    className="form-control"
                                    id="phone"
                                />
                            </div>
                            {/* <div className="mb-3">
                                <label htmlFor="deliveryTax" className="form-label">Taxa de entrega</label>
                                <input
                                    type="text"
                                    name="deliveryTax"
                                    value={personData ? personData.deliveryTax : ''}
                                    onChange={handlePersonChange}
                                    className="form-control"
                                    id="deliveryTax"
                                />
                            </div> */}
                        </div>
                        <div className="change-btn d-flex align-items-center align-content-center p-3 justify-content-center flex-wrap">
                            <button type="submit" className="btn btn-outline-primary" style={{ maxWidth: 270, width: '100%', margin: '15 auto' }}
                                onClick={() => updateProfile()}>Atualizar dados</button>
                        </div>
                        <div className='col-12'>
                            <br />
                            <h3><i className="bi bi-person-lines-fill"></i> Endereço </h3>
                            <hr />
                        </div>
                        <div className="mb-3">
                            {/* fazer um if a partir daqui pra separar o endereço atual do cadastro do novo endereo */}
                            {toggle ? (
                                isEditingAddress ? (
                                    <div className="row">
                                        <AddressAutocompleteOSM
                                            onSelectAddress={(addr) => {
                                                setPersonData({
                                                    ...personData,
                                                    addresses: [
                                                        {
                                                            ...personData.addresses?.[0],
                                                            ...addr,
                                                        },
                                                    ],
                                                });
                                                setShowAddressFields(true);
                                            }}
                                        />
                                        {showAddressFields && (
                                            <div className="row">
                                                <div className="col-md-12 mt-2 mb-3" style={{ display: "flex" }}>
                                                    <hr className="mb-3 mt-3" style={{ width: "Calc(50% - 15px)" }} />
                                                    <div className="w-100 text-center pt-2">
                                                        <b>Confirmar novo endereço</b>
                                                    </div>
                                                    <hr className="mb-3 mt-3" style={{ width: "Calc(50% - 15px)" }} />
                                                </div>

                                                <div className="col-md-12 mt-2 mb-3">
                                                    <MapContainer
                                                        center={[
                                                            parseFloat(personData.addresses?.[0]?.latitude) || -15.7797,
                                                            parseFloat(personData.addresses?.[0]?.longitude) || -47.9297,
                                                        ]}
                                                        zoom={15}
                                                        style={{ height: "300px", width: "100%" }}
                                                    >
                                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                                        <Marker
                                                            position={[
                                                                parseFloat(personData.addresses?.[0]?.latitude),
                                                                parseFloat(personData.addresses?.[0]?.longitude),
                                                            ]}
                                                        />
                                                    </MapContainer>
                                                </div>

                                                {[
                                                    ["Rua", "street"],
                                                    ["Número", "number"],
                                                    ["Bairro", "neighborhood"],
                                                    ["Cidade", "city"],
                                                    ["Estado", "state"],
                                                    ["CEP", "zipCode"],
                                                ].map(([label, field]) => (
                                                    <div className="col-md-6 mb-2" key={field}>
                                                        <label className="form-label">{label}</label>
                                                        <div
                                                            style={{
                                                                backgroundColor: "rgb(233 233 233)",
                                                                width: "100%",
                                                                border: 0,
                                                                borderRadius: 3,
                                                            }}
                                                            className="py-3 px-1 text-center"
                                                        >
                                                            {personData.addresses?.[0]?.[field] || "-"}
                                                        </div>
                                                    </div>
                                                ))}

                                                <div className="col-12 text-center mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary me-2"
                                                        onClick={() => setIsEditingAddress(false)}
                                                    >
                                                        Cancelar
                                                    </button>
                                                    <button onClick={() => handleAddressSubmit(personData.addresses[0])} type="button" className="btn btn-success">
                                                        Salvar endereço
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    // Exibição do endereço atual
                                    <div className="row mt-2">
                                        <div className="col-md-12 mb-2">
                                            <MapContainer
                                                center={[
                                                    parseFloat(personData.addresses?.[0]?.latitude) || -15.7797,
                                                    parseFloat(personData.addresses?.[0]?.longitude) || -47.9297,
                                                ]}
                                                zoom={15}
                                                style={{ height: "300px", width: "100%" }}
                                            >
                                                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                                <Marker
                                                    position={[
                                                        parseFloat(personData.addresses?.[0]?.latitude),
                                                        parseFloat(personData.addresses?.[0]?.longitude),
                                                    ]}
                                                />
                                            </MapContainer>
                                            <div
                                                style={{
                                                    backgroundColor: "rgb(233 233 233)",
                                                    borderRadius: 5,
                                                    padding: "10px 15px",
                                                }}
                                            >
                                                <p><b>Rua:</b> {personData?.addresses?.[0]?.street || "-"}</p>
                                                <p><b>Número:</b> {personData?.addresses?.[0]?.number || "-"}</p>
                                                <p><b>Bairro:</b> {personData?.addresses?.[0]?.neighborhood || "-"}</p>
                                                <p>
                                                    <b>Cidade:</b> {personData?.addresses?.[0]?.city} -{" "}
                                                    {personData?.addresses?.[0]?.state}
                                                </p>
                                                <p><b>CEP:</b> {personData?.addresses?.[0]?.zipCode || "-"}</p>
                                            </div>
                                        </div>

                                        <div className="col-12 text-center mt-3">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() => setIsEditingAddress(true)}
                                            >
                                                Alterar endereço
                                            </button>
                                        </div>
                                    </div>
                                )
                            ) : null}
                        </div>
                        {/* <div className='col-12'>
                            <br /><br />
                            <div className="change-btn d-flex align-items-center align-content-center bg-light p-3 justify-content-center flex-wrap">
                                <button type="submit" className="btn btn-primary border-primary" style={{ maxWidth: 270, width: '100%', margin: '15 auto' }} onClick={() => setModalNewAddress(true)} >Cadastrar novo endereços</button>
                            </div>
                        </div>  */}
                    </div>
                </form>
            )}
            {/* <Modal show={modalNewAddress} onHide={setModalNewAddress} centered>
                <button onClick={() => setModalNewAddress(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <h4 style={{ borderBottom: '1px solid #f1f1f1', paddingBottom: 7 }}><i className="fa-solid fa-location-dot"></i> Cadastrar Novo Endereço </h4>
                    <br />
                    <NewAddressForm onSubmit={handleAddressSubmit} onCancel={() => handleCancelNewAddress()} />
                </div>
            </Modal> */}
            <Modal show={modalMSG} onHide={setModalMSG} centered>
                <button onClick={() => setModalMSG(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>
                <div className='d-flex align-items-center justify-content-center flex-column p-4' style={{ minHeight: 300 }}>
                    <h2 style={{ paddingBottom: 3 }}><i class="bi bi-exclamation-triangle"></i></h2>
                    <h4 style={{ paddingBottom: 7 }}>{message}</h4>
                </div>
            </Modal>
            <span style={{ zIndex: 9999, width: '100%', height: '100vh', backgroundColor: 'rgba(41 ,180,226,0.6)', position: 'absolute', top: 0, right: 0, display: loading ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center' }} >
                <i id="loading-arrow-in-circle" className="bi bi-arrow-clockwise" style={{ color: 'white', fontSize: 75 }}></i>
            </span>
        </>
    );
};

const AddressAutocompleteOSM = ({ onSelectAddress }) => {
    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const extractNumberFromQuery = (input) => {
        // Regex para pegar primeiro número no input
        const match = input.match(/\b\d+\b/);
        return match ? match[0] : "";
    };

    const removeNumberFromQuery = (input, number) => {
        if (!number) return input;
        // Remove apenas a primeira ocorrência do número
        return input.replace(number, "").replace(/\s{2,}/g, " ").trim();
    };

    const searchAddress = async () => {
        if (!query || query.length < 3) {
            setSuggestions([]);
            return;
        }

        const number = extractNumberFromQuery(query);
        const queryWithoutNumber = removeNumberFromQuery(query, number);

        try {
            const response = await fetch(
                `https://bot.pskeromais.com.br/api/street-founder?q=${encodeURIComponent(
                    queryWithoutNumber
                )}`
            );
            const data = await response.json();
            setSuggestions(Array.isArray(data) ? data : []);
            // abre o modal com os resultados
            setShowModal(true);
        } catch (error) {
            console.error("Erro ao buscar endereço OSM:", error);
            setSuggestions([]);
            setShowModal(true); // abre modal mesmo que vazio (pode exibir "Nenhum endereço")
        } finally {
            setLoading(false);
        }
    };

    const formatAddress = (item, number = "") => {
        const addr = item.address || {};
        return [
            [addr.road, number || addr.house_number].filter(Boolean).join(", "), // rua + número
            addr.suburb, // bairro
            addr.city || addr.town || addr.village, // cidade
            addr.state, // estado
            addr.postcode, // CEP
            addr.country, // país
        ]
            .filter(Boolean)
            .join(", ");
    };

    const handleSelect = (item) => {
        const number = extractNumberFromQuery(query); // pega o número que o usuário digitou
        const formatted = formatAddress(item, number);
        setQuery(formatted);
        setSuggestions([]);

        const { address, lat, lon } = item;
        const payload = {
            number: number || address.house_number || "",
            street: address.road || "",
            city: address.city || address.town || address.village || "",
            state: address.state || "",
            zipcode: address.postcode || "",
            neighborhood: address.suburb || "",
            country: 'Brasil',
            latitude: parseFloat(lat) || 0,
            longitude: parseFloat(lon) || 0,
        };

        onSelectAddress(payload);
    };

    return (
        <div style={{ position: "relative" }}>
            <div style={{ display: "flex", gap: 6 }}>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Digite seu endereço"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={searchAddress}
                    disabled={query.length < 3 || loading}
                    title="Buscar endereço"
                >
                    <i className="bi bi-search" />
                </button>
            </div>

            {loading && <div style={{ marginTop: 6, fontSize: 16, margin: "13px 0" }}><div className="spinner-border text-primary" role="status">
                <span className="visually-hidden"></span>
            </div> Procurando endereço...</div>
            }

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <button
                    onClick={() => setShowModal(false)}
                    className="btn btn-light p-1"
                    style={{
                        width: 30,
                        height: 30,
                        position: "absolute",
                        right: 6,
                        top: 6,
                        borderRadius: "100%",
                        zIndex: 1051,
                    }}
                >
                    <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
                </button>

                <div
                    className="d-flex align-items-center justify-content-center flex-column p-4"
                    style={{ minHeight: 200 }}
                >
                    <h4 style={{ borderBottom: "1px solid #f1f1f1", paddingBottom: 7 }}>
                        <i className="fa-solid fa-location-dot"></i> Endereços encontrados
                    </h4>
                    <br />
                    <div style={{ width: "100%" }}>
                        {loading ? (
                            <p>Carregando...</p>
                        ) : suggestions.length > 0 ? (
                            <ul
                                className="list-group"
                                style={{ maxHeight: 300, overflowY: "auto" }}
                            >
                                {suggestions.map((item) => (
                                    <li
                                        key={item.place_id}
                                        className="list-group-item list-group-item-action"
                                        style={{
                                            cursor: "pointer",
                                            backgroundColor: "#fff",
                                            display: "flex",
                                            gap: 8,
                                            alignItems: "center",
                                        }}
                                        onClick={() => (handleSelect(item) , setShowModal(false))}
                                    >
                                        <i className="bi bi-geo-alt" style={{ fontSize: 18 }} />
                                        <div style={{ lineHeight: 1.1 }}>
                                            {formatAddress(item, extractNumberFromQuery(query))}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>Nenhum endereço encontrado.</p>
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default CadastroForm;